import request from "./request";

export async function postComment(body) {
  return await request.post("/api/comment", body);
}

export async function getComment(page = 1, limit = 10, blogid = -1) {
  return await request.get("/api/comment", {
    params: {
      page,
      limit,
      blogid,
    },
  });
}
